export const сonfidentialOptions = [
  { value: 1, label: 'Yes' },
  { value: 0, label: 'No' },
];

export const statusOptions = [
  { value: 0, label: 'Active' },
  { value: 1, label: 'Inactive' },
];
